/** Redux Packages. */
import { createSlice } from '@reduxjs/toolkit';

/** Accounting tabs — 0: IN PROGRESS (Payment Requested), 1: COMPLETE (Payment Sent). */
const TABS = [0, 1];

/**
 * refreshSeq counts Collect Charge status changes made by anyone. A status decides which tab a
 * shipment sits in, so the Accounting page re-reads the open tab when it moves.
 */
const initialState = {
    0: [],
    1: [],
    refreshSeq: 0,
};

const accountingSlice = createSlice({
    name: 'accountingList',
    initialState: initialState,
    reducers: {
        setAccountingData: (state, action) => {
            const { tabValue, data } = action.payload;
            state[tabValue] = Array.isArray(data) ? data : [];
        },
        updateAccountingData: (state, action) => {
            const updateInRows = (rows, id, key, value) => {
                const target = rows?.find((accounting) => accounting.id === id);
                if (target) {
                    target[key] = value;
                    return true;
                }
                return false;
            };

            const updateAcrossTabs = (id, key, value) => {
                for (const tab of TABS) {
                    if (updateInRows(state[tab], id, key, value)) {
                        break;
                    }
                }
            };

            // 배열로 들어오는 경우: tabValue 없이 모든 탭을 뒤져서 id 매칭
            if (Array.isArray(action.payload)) {
                action.payload.forEach((item) => {
                    if (!item || item.id == null) return; // id 없으면 무시
                    updateAcrossTabs(item.id, item.key, item.value);
                    if (item.key === 'freight') state.refreshSeq += 1;
                });
                return;
            }

            // 단일 객체로 들어오는 경우 (기존 방식)
            const { id, key, value, tabValue } = action.payload;

            if (tabValue != null && updateInRows(state[tabValue], id, key, value)) {
                return;
            }

            // Fallback: find across tabs (e.g. socket broadcasts without tabValue)
            updateAcrossTabs(id, key, value);
            // Only server broadcasts land here (after the save), so the re-read sees the new status.
            if (key === 'freight') state.refreshSeq += 1;
        },

        resetAccountingData: () => {
            return initialState;
        },
    },
});

export const { setAccountingData, updateAccountingData, resetAccountingData } = accountingSlice.actions;
export default accountingSlice.reducer;
